import { Localized } from "@fluent/react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { DocumentNumberBox } from "../../../app/components/DocumentNumberBox";
import { URSRequirement } from "../UrsSlice";

interface RequirementDisplayComponentProps {
    requirement: URSRequirement;
    withTopMargin?: boolean;
}

export const RequirementDisplayComponent = ({ requirement, withTopMargin = true }: RequirementDisplayComponentProps) => {
    return (
        <Stack spacing={0.75} sx={{ mt: withTopMargin ? 1 : 0, mb: 2 }}>

            <Paper
                variant="outlined"
                sx={{
                    p: 2,
                    borderColor: "grey.300",
                    backgroundColor: "grey.50",
                }}
            >
                <Stack spacing={1.5}>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <DocumentNumberBox value={requirement.numeration ?? requirement.code ?? requirement.id} />
                    </Stack>

                    <Box
                        sx={{
                            color: "text.primary",
                            "& p": { margin: 0 },
                            "& p + p": { marginTop: 0.75 },
                        }}
                    >
                        <div dangerouslySetInnerHTML={{ __html: requirement.name }}></div>
                    </Box>
                </Stack>
            </Paper>
        </Stack>
    );
};
